import * as companyresource from '@/services/ITMarket/companyresource';

export default {
  namespace: 'CompanyITResource_CompanyList',
  state: {
    data: {},
    ScribePrice: [],
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
  effects: {
    *fetchNet({ payload }, { call, put }) {
      const { status, data } = yield call(
        companyresource.queryRsNetCompany,
        payload
      );
      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },
  },
};
